// extracted by mini-css-extract-plugin
export default {"collapse":"Collapse_collapse__emVhd","collapseText":"Collapse_collapseText__LXMG1","collapseIcon":"Collapse_collapseIcon__fRe7h"};